import { connect } from "react-redux";

import { getBannerType } from "@template/state/modules/infoBanner";

import InfoBannerControl from "./InfoBannerControl";

const mapStateToProps = state => ({
  bannerType: getBannerType(state)
});

export default connect(mapStateToProps)(InfoBannerControl);
